/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterDraftFixedAssetListResponse,
  PresenterError,
  PresenterImportStartDateResponse,
  PresenterResponse,
  PresenterSaveImportStartDateRequest,
  PresenterSusJournalListResponse,
  PresenterSusJournalRefreshResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class SuspenseAccount<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Returns the office's draft fixed assets (status=NotReflected). Columns mirror the FA-ledger view (horizontally scrollable per Figma). Total count is returned in meta.total.
   *
   * @tags suspense_account
   * @name DraftAssetsList
   * @summary List draft fixed assets (not reflected to ledger)
   * @request GET:/suspense_account/draft_assets
   */
  draftAssetsList = (
    query?: {
      /** Asset-name substring match */
      name?: string;
      /** Filter by asset category */
      asset_category_id?: number;
      /** Filter by department BIID */
      department_biid?: string;
      /** Filter by area BIID */
      area_biid?: string;
      /** Page number (1-based; default 1) */
      "page[number]"?: number;
      /** Page size (default 50) */
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns all already-imported AccPlus journal branch sides for the office. selected_month is optional: when provided it acts as a month guard against the current monthly closing (future months return 400; past months return empty); when omitted the endpoint returns everything for the office (subject to paging and journal_ids). last_fetched_at is included so the FE can render the "最終取得日時" label.
   *
   * @tags suspense_account
   * @name JournalBranchSidesList
   * @summary List suspense-account journals
   * @request GET:/suspense_account/journal_branch_sides
   */
  journalBranchSidesList = (
    query?: {
      /** Optional month guard, YYYY-MM; omit to return all */
      selected_month?: string;
      /** Page number (1-based; default 1) */
      "page[number]"?: number;
      /** Page size (default/max 2000) */
      "page[size]"?: number;
      /** Optional sus_journal IDs filter; omit to return all */
      journal_ids?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalListResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journal_branch_sides`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh suspense-account journals from AccPlus
   *
   * @tags suspense_account
   * @name JournalsRefreshCreate
   * @summary Refresh suspense-account journals from AccPlus
   * @request POST:/suspense_account/journals/refresh
   */
  journalsRefreshCreate = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterSusJournalRefreshResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/journals/refresh`,
      method: "POST",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the current office's import settings (import_start_date).
   *
   * @tags suspense_account
   * @name SettingsImportStartDateList
   * @summary Get suspense-account import settings
   * @request GET:/suspense_account/settings/import_start_date
   */
  settingsImportStartDateList = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterImportStartDateResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/settings/import_start_date`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upsert the office's import_start_date. Returns the persisted setting.
   *
   * @tags suspense_account
   * @name SettingsImportStartDateCreate
   * @summary Save suspense-account import start date
   * @request POST:/suspense_account/settings/import_start_date
   */
  settingsImportStartDateCreate = (
    body: PresenterSaveImportStartDateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterImportStartDateResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/settings/import_start_date`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
